module.exports = __webpack_public_path__ + "static/media/certificate-img.5202dc99.png";